"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.001.001c-4.41 0-7.999 3.589-7.999 8a7.94 7.94 0 0 0 2.345 5.652A7.941 7.941 0 0 0 8 15.998c4.41 0 7.998-3.588 7.998-7.998a7.944 7.944 0 0 0-2.344-5.654A7.945 7.945 0 0 0 8.001.001Zm0 1c3.858 0 6.997 3.14 6.997 6.998 0 3.86-3.139 7-6.998 7-3.859 0-6.999-3.14-6.998-6.998a7.007 7.007 0 0 1 7-7ZM8.5 8.5h5v-1h-5v-5h-1v5h-5v1h5v5h1v-5Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.99.02C5.397.02.03 5.386.03 11.98a11.88 11.88 0 0 0 3.507 8.454 11.878 11.878 0 0 0 8.453 3.507c6.594 0 11.958-5.366 11.958-11.96 0-3.191-1.245-6.193-3.505-8.455A11.876 11.876 0 0 0 11.99.02Zm0 1.125c5.975 0 10.833 4.86 10.833 10.835 0 5.975-4.859 10.836-10.832 10.836-5.975 0-10.836-4.861-10.836-10.836 0-5.974 4.861-10.835 10.836-10.835Zm.572 11.261h8.063v-1.125h-8.063V3.22h-1.124v8.063H3.374v1.124h8.063v8.063h1.124v-8.063Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M15.987.027C7.194.027.04 7.18.04 15.974c0 4.253 1.66 8.256 4.676 11.27a15.837 15.837 0 0 0 11.27 4.677c8.792 0 15.945-7.154 15.945-15.947 0-4.254-1.66-8.257-4.674-11.272A15.835 15.835 0 0 0 15.987.027Zm0 1.5c7.966 0 14.444 6.48 14.444 14.447 0 7.966-6.479 14.447-14.444 14.447-7.966 0-14.447-6.481-14.447-14.447 0-7.966 6.481-14.447 14.447-14.447Zm.763 15.015H27.5v-1.5H16.75V4.292h-1.5v10.75H4.5v1.5h10.75v10.75h1.5v-10.75Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M24.013.043C10.803.043.058 10.79.058 23.998c0 6.389 2.494 12.402 7.023 16.931 4.529 4.53 10.542 7.024 16.932 7.024 13.206 0 23.95-10.746 23.95-23.955.002-6.39-2.493-12.402-7.02-16.931-4.53-4.53-10.541-7.024-16.93-7.024Zm0 1.875c12.174 0 22.077 9.905 22.076 22.08 0 12.175-9.902 22.08-22.076 22.08-12.175 0-22.08-9.905-22.08-22.08 0-12.175 9.905-22.08 22.08-22.08Zm.935 23.02h17.104v-1.875H24.948V5.959h-1.875v17.104H5.97v1.875h17.103V42.04h1.875V24.938Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M32.017.058C14.405.058.077 14.386.077 31.998c0 8.518 3.326 16.536 9.364 22.575 6.039 6.039 14.057 9.365 22.576 9.365 17.609 0 31.935-14.328 31.935-31.94 0-8.52-3.325-16.536-9.362-22.575C48.552 3.383 40.536.058 32.017.058Zm0 2.5c16.233 0 29.436 13.207 29.435 29.44 0 16.233-13.203 29.44-29.435 29.44-16.233 0-29.44-13.207-29.44-29.44s13.207-29.44 29.44-29.44Zm1.247 30.692h22.805v-2.5H33.264V7.946h-2.5V30.75H7.96v2.5h22.804v22.805h2.5V33.25Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconAddItem = function IconAddItem(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Add Item' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "AddItem"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconAddItem.sizes = [16, 24, 32, 48, 64];
IconAddItem.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconAddItem;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/AddItem.js
// module id = 2315
// module chunks = 0